import { CommonCallout } from 'components/common/callouts';

export const InactiveCallout = () => (
  <CommonCallout text="settings.inactive-warning-msg" />
);
